'use client';

import clsx from 'clsx';
import { useRef } from 'react';
import { useScrollY } from '../_hooks/useScrollY';

export default function ScrollTopButton() {
  const refButton = useRef<HTMLButtonElement>(null);
  const scrollPosition = useScrollY();
  const isActive = scrollPosition > 0;

  const scrollTop = () => {
    document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <button className={clsx('btn_scroll_top', isActive && 'active')} type="button" ref={refButton} onClick={scrollTop}>
      <i className="icon_scroll_top" />
      <span className="text_blind">스크롤 최상단으로</span>
    </button>
  );
}
